<!--<<<<<<< HEAD-->
<card *routerOuter [name]="'User ' + (item?.account?.email || id) + (item?.store ? ' at ' + item.store.name : '')">
  <div card controls>
<!--=======-->
<!--<card [name]="'User ' + (item?.account?.email || id) + (item?.store ? ' at ' + item.store.name : '')">-->
<!--  <div card controls>-->
<!--&gt;>>>>>> origin/fixBugs-->
    <tabs-route [items]="routes"></tabs-route>
  </div>

  <div card content>
    <router-outlet></router-outlet>
  </div>
</card>
